import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";

const Simulation = () => {
  return (
    <div className="blog">
      <div className="container">
        <div className="content">
          <Link to="/writings" className="back-link">
            ← back to writings
          </Link>
          <div className="blog-header-row">
            <div className="flex gap-4 items-center flex-row">
              <h1>simulation</h1>
            </div>
            <p className="blog-date">2026-07-05</p>
          </div>
          <div className="border-b border-gray-400 text-gray-700 py-2">
            the secret to simulation 🤫
          </div>
          <div className="blog-content">
            <div className="blog-body">
              <p>
                Current survey data exists, but they cap the ceiling of simulation. The future of simulation for all purposes—population and individual level simulation—necessitates premium data: authentic, longitudinal, diverse demographic (wealth, race), and qualitative rich data.
              </p>

              <p>
                Traditional data collection methods are flawed in every requirement, respectively: There is a difference from what people say and do when you pay them; People aren't always available to run a survey on at a moments timestep; You can't buy time from people who are already wealthy; Surveys contain mainly check boxes, ordinal and binary data—a more scalable, but lossy compression of data.
              </p>

              <p>
                The only way to reach all of these data requirements is with a consumer product people love. The most valuable resource is time, yet people waste entire years on bad decisions. "But how can you call a decision bad?" Leading up to now, you've already went through countless decisions with countless outcomes. The problem is most learning are forgotten, humans have some maximum storage of memory. No matter how vivid a negative experience is, it seems there will always be some learnings that sneak past us despite having relevance in the current moment.
              </p>

              <p>
                Some people see the value in internalizing these learnings: It's why people journal. Yet even here, we are still bounded by our own ability to remember past entries. So, instead of relying on our brains to pattern-match and find the relevant learnings at decision-time, what if we had a model of ourselves. Just like any other model, that takes inputs and outputs, only now the input is your current context and the output is the expected outcome based off your past experiences. What you do next is completely up to you, but now you have the factual evidence to make the new decision. To make a more informed decision. To make the right decision.
              </p>

              <p>
                Of course, you won't know the right decision at every step. Even if it were the goal, the result isn't a dystopian novel where you can outsource all thinking. Sure, many experiences can be abstracted and used as reference for related moments in the future; however, throughout life you will naturally encounter completely new experiences. It's impossible for the model to predict outcomes based off loose data. Just like the human it was based off of, the model will be ever-changing, adapting to the inevitable unpredictability of life. What it can do though, is help you improve faster at any aspect of life: productivity, work, relationships.
              </p>

              <p>
                The app would catch you when you resort to doom-scrolling as an avoidant coping mechanism despite it always leaving you feeling worse afterwards; when you're skipping the walk you have never once regretted taking; when you're over-apologizing to your partner once again and setting promises that you can't keep (true story). By using a model that leverages past experiences to essentially help you learn more efficiently, you gain the time to focus on making novel mistakes instead of wasting time on ones you should've already internalized. You never have to make the same mistake again.
              </p>

              <p>
                You give your context as input for the simulation model, which only makes the model more accurate. Which in turn, incentives you to keep giving context to (and getting value from) the model.
              </p>

              <p>
                Whether creating a population simulation or a personal simulation, it requires understanding that humans are complex. And because of that complexity, there is no way to short-cut getting this quality data: the incentives must be aligned.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Simulation;
